
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "commitHash": "a23fb981e79462489c07a1e4656f310390cb1148",
    "version": "17.1.0"
};
